import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const Box = styled.div`
  position: relative;
  width: 100%;
  input {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    border: 1px solid;
    direction: ${props => (props.alignLeft ? "ltr" : "rtl")};
    padding: 6px 8px 3px 8px;
    border-color: ${props => {
      switch (props.status) {
        case "warning":
          return Variables.colors.yellow_500;
        case "error":
          return Variables.colors.red_600;
        case "success":
          return Variables.colors.green;
        default:
          return Variables.colors.complementary_500;
      }
    }};
    &:focus {
      border-color: ${props => {
        switch (props.status) {
          case "warning":
            return Variables.colors.yellow_500;
          case "error":
            return Variables.colors.red_600;
          case "success":
            return Variables.colors.green;
          default:
            return Variables.colors.primary_vivid;
        }
      }};
    }
  }
  .notice {
    //margin-bottom: 8px;
    display: block;
    padding: 4px 0;
    font-size: ${Variables.font_sizes.x_small};
    position: absolute;
    bottom: -21px;
    right: 5px;
    color: ${props => {
      switch (props.status) {
        case "warning":
          return Variables.colors.yellow_500;
        case "error":
          return Variables.colors.red_600;
        case "success":
          return Variables.colors.green;
        default:
          return Variables.colors.complementary_500;
      }
    }};
  }
`;
